import Vue from 'vue'
import VueRouter from 'vue-router'
import Dash from '../views/Dash.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/user_signup/:token',
    name: 'UserSignup',
    component: () => import(/* webpackChunkName: "home" */ '../views/UserSignup.vue')
  },
  {
    path: '/forgot-pass',
    name: 'ForgotPassRequest',
    component: () => import(/* webpackChunkName: "login" */ '../views/ForgotPassword.vue')
  },
  {
    path: '/password_reset/:token',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "login" */ '../views/ResetPassword.vue')
  },
  {
    path: '/',
    name: 'Dash',
    component: Dash,
    children: [
      {
        path: '/admin',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
      },
      {
        path: '/menu',
        name: 'Menu',
        component: () => import(/* webpackChunkName: "home" */ '../views/Menu.vue')
      },
      {
        path: '/permission',
        name: 'Permission',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Permission.vue')
      },
      {
        path: '/chats',
        name: 'Chats',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Chats.vue')
      },
      {
        path: '/contacts',
        name: 'Contacts',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Contacts.vue')
      },
      {
        path: '/messages',
        name: 'Messages',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Messages.vue')
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Settings.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = window.localStorage.getItem('token') !== 'null'
  console.log(window.localStorage.getItem('token'))
  console.log(isAuthenticated)
  console.log(typeof window.localStorage.getItem('token'))
  if (to.name !== 'Login' && !isAuthenticated) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.session !== localUser) {
    store.dispatch('session/setUser', localUser)
    store.dispatch('session/setToken', window.localStorage.getItem('token'))
  }
}

export default router
